<section class="queue" data-testid="exception-queue-panel">
  <header class="queue__header">
    <div>
      <h3 class="queue__title">Documentos retidos</h3>
      <p class="queue__subtitle">
        Estrutura Contábil processada que não validou sozinha, com o motivo. Abra o documento para
        corrigir ou validar com motivo.
      </p>
    </div>
    <app-button
      [label]="'Atualizar'"
      [icon]="'pi pi-refresh'"
      [theme]="'white'"
      [type]="'button'"
      [disabled]="isLoading()"
      (sendButtonClick)="reload()" />
  </header>

  @if (isLoading()) {
    <div class="queue__loading">
      <app-cog-loading-spinner [size]="64" />
    </div>
  } @else if (errorMessage(); as message) {
    <p class="queue__error" role="alert">{{ message }}</p>
  } @else if (total() === 0) {
    <p class="queue__empty" data-testid="exception-queue-empty">
      Nenhum documento retido nas empresas do filtro. Tudo o que foi processado validou ou ainda
      está em processamento.
    </p>
  } @else {
    <div class="queue__summary" role="list">
      @for (rule of summary(); track rule.rule) {
        <button
          type="button"
          role="listitem"
          class="queue__rule"
          [class.queue__rule--active]="selectedRule() === rule.rule"
          [attr.aria-pressed]="selectedRule() === rule.rule"
          data-testid="exception-queue-rule"
          (click)="toggleRule(rule.rule)">
          <span class="queue__rule-count">{{ rule.count }}</span>
          <span class="queue__rule-label">{{ rule.label }}</span>
          <span class="queue__rule-age">idade média {{ rule.averageAge }}</span>
        </button>
      }
    </div>

    @if (selectedRule()) {
      <p class="queue__filter-note">
        Mostrando só "{{ rows()[0]?.ruleLabel ?? selectedRule() }}".
        <button type="button" class="queue__link" (click)="toggleRule(selectedRule()!)">
          Mostrar todas
        </button>
      </p>
    }

    <div class="queue__table" role="table">
      <div class="queue__row queue__row--head" role="row">
        <span role="columnheader">Empresa</span>
        <span role="columnheader">Documento</span>
        <span role="columnheader">Motivo</span>
        <span role="columnheader">Retido</span>
      </div>
      @for (row of rows(); track row.item.extractionId) {
        <button
          type="button"
          role="row"
          class="queue__row"
          data-testid="exception-queue-row"
          title="Abrir o documento"
          (click)="open(row.item)">
          <span role="cell" class="queue__company">{{ row.item.companyName ?? '—' }}</span>
          <span role="cell" class="queue__document">{{ row.item.documentName ?? '—' }}</span>
          <span role="cell" class="queue__reason">
            <strong>{{ row.ruleLabel }}</strong>
            @if (row.item.reason) {
              <span>{{ row.item.reason }}</span>
            }
          </span>
          <span role="cell" class="queue__age">{{ row.age }}</span>
        </button>
      }
    </div>
  }
</section>
